var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountBigYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 108,
    viewBox: "0 0 93 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1567 58.3818C20.8671 58.3818 0.582703 78.556 0.582703 103.708C0.582703 105.542 2.1633 107.114 4.00734 107.114C5.85137 107.114 7.43197 105.542 7.43197 103.708C7.43197 82.4861 24.8186 64.9319 46.4201 64.9319C67.7582 64.9319 85.4083 82.2241 85.4083 103.708C85.4083 105.542 86.9889 107.114 88.8329 107.114C90.6769 107.114 92.2575 105.542 92.2575 103.708C91.4672 78.556 71.1829 58.3818 46.1567 58.3818Z",
    fill: "#F3DD8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1567 54.4518C61.1724 54.4518 73.2904 42.3996 73.2904 27.4655C73.2904 12.5313 60.909 0.741211 46.1567 0.741211C31.141 0.741211 19.0231 12.7933 19.0231 27.7275C19.0231 42.6616 31.141 54.4518 46.1567 54.4518ZM46.1567 7.29128C57.4844 7.29128 66.7045 16.4614 66.7045 27.7275C66.7045 38.9936 57.2209 47.9017 46.1567 47.9017C35.0925 47.9017 25.6089 38.7316 25.6089 27.4655C25.6089 16.1994 34.8291 7.29128 46.1567 7.29128Z",
    fill: "#F3DD8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBigYellow);
export default __webpack_public_path__ + "static/media/accountBigYellow.3537a4e183f8a797513bb4ec03f2199c.svg";
export { ForwardRef as ReactComponent };